import { render, staticRenderFns } from "./TheSettings.vue?vue&type=template&id=68de052c&"
import script from "./TheSettings.vue?vue&type=script&lang=ts&"
export * from "./TheSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68de052c')) {
      api.createRecord('68de052c', component.options)
    } else {
      api.reload('68de052c', component.options)
    }
    module.hot.accept("./TheSettings.vue?vue&type=template&id=68de052c&", function () {
      api.rerender('68de052c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheSettings.vue"
export default component.exports